document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('[data-component]').forEach(el => {
        const template = document.getElementById(`${el.dataset.component}-template`);

        if (!template) return;

        el.replaceWith(template.content.cloneNode(true));
    });

    breakTitlesAfterColon();
    keepShortWordsTogether();

    fitBannerText();
    document.fonts.ready.then(fitBannerText);

    let resizeFrame;
    window.addEventListener('resize', () => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(fitBannerText);
    });
});

// #titulo-quebra: for posts with that tag (slugs listed by default.hbs),
// break the home Capa title after its first ":". Only there — the same
// post's title stays on one line everywhere else. Matched by the post
// link around it.
function breakTitlesAfterColon() {
    const data = document.getElementById('titulo-quebra-slugs');
    if (!data) return;

    let slugs;
    try {
        slugs = new Set(JSON.parse(data.textContent));
    } catch (e) {
        return;
    }
    if (!slugs.size) return;

    const slugOf = href => {
        try {
            const parts = new URL(href, location.href).pathname.split('/').filter(Boolean);
            return parts[parts.length - 1];
        } catch (e) {
            return null;
        }
    };

    document.querySelectorAll('.section--capa .capa-title').forEach(title => {
        const link = title.closest('a[href]');
        const slug = link && slugOf(link.getAttribute('href'));
        if (!slug || !slugs.has(slug)) return;

        const walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
            const match = node.nodeValue.match(/:\s+/);
            if (!match) continue;

            const after = node.splitText(match.index + 1);
            after.nodeValue = after.nodeValue.replace(/^\s+/, '');
            after.parentNode.insertBefore(document.createElement('br'), after);
            title.dataset.tituloQuebra = '';
            return;
        }
    });
}

// Portuguese typography: a one-letter word ("a", "e", "o", "à", "A"…)
// shouldn't be left alone at the end of a line, which text-wrap:
// balance happily does. A non-breaking space after it keeps it with
// the next word. Applied to every heading/title.
function keepShortWordsTogether() {
    const shortWord = /(^|[^\p{L}\p{N}])(\p{L}) (?=\S)/gu;

    document.querySelectorAll('h1, h2, h3, h4, [class*="-title"]').forEach(el => {
        const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
        let node;

        while ((node = walker.nextNode())) {
            let text = node.nodeValue;
            let previous;

            // Twice-over until stable: back-to-back short words ("a e")
            // share the space between them, so one pass misses the second.
            do {
                previous = text;
                text = text.replace(shortWord, '$1$2 ');
            } while (text !== previous);

            if (text !== node.nodeValue) {
                node.nodeValue = text;
            }
        }
    });
}

// Wrapped text leaves its box at full width with empty space after the
// shorter lines, which pushes the centred logo + text group off-centre.
// Shrinks the box to its longest rendered line (CSS can't).
function fitBannerText() {
    document.querySelectorAll('.banner-jose-fontana-text, .banner-whatsapp-text').forEach(text => {
        text.style.width = '';

        const left = text.getBoundingClientRect().left;
        let widest = 0;

        text.querySelectorAll('p').forEach(p => {
            const range = document.createRange();
            range.selectNodeContents(p);
            for (const rect of range.getClientRects()) {
                widest = Math.max(widest, rect.right - left);
            }
        });

        if (widest) {
            text.style.width = `${Math.ceil(widest) + 1}px`;
        }
    });
}
